<template>
  <v-container>
    <v-card class="px-2">
      <input
        id="user-id"
        type="hidden"
        v-model="ordem.usuario"
      >
      <input
        id="ordem-uuid"
        type="hidden"
        v-model="ordem.id"
      >
      <input
        id="ordem-id"
        type="hidden"
        v-model="ordem.uuid"
      >
      <v-row>
        <v-col
          cols="12"
          md="2"
        >
          <v-text-field
            v-model="codigo"
            label="Código"
            dense
            outlined
            @change="loadOrdem()"
          >
            <v-btn
              class="btn-outer-right pa-0"
              slot="append"
              color="success"
              tile
              @click.prevent="loadDialog"
            >
              <v-icon
                class="mx-0"
                color="white"
              >
                mdi-magnify
              </v-icon>
            </v-btn>
          </v-text-field>
        </v-col>
        <v-col
          cols="12"
          md="3"
          lg="2"
          v-if="codigo"
        >
          <v-checkbox
            v-model="ordem.inativar"
            label="Inativar ordem?"
            color="success"
          ></v-checkbox>
        </v-col>
        <v-col
          colls="12"
          lg="2"
          md="5"
          sm="12"
        >
          <v-menu
            v-model="menu"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-mask="datacad"
                v-model="data_cad"
                label="Data do cadastro.:"
                dense
                outlined
                @blur="mudaDataA"
              >
                <v-icon
                  slot="append"
                  color="success"
                  large
                  v-bind="attrs"
                  v-on="on"
                >
                  mdi-calendar
                </v-icon>
              </v-text-field>
            </template>
            <v-date-picker
              locale="pt-br"
              v-model="date0"
              @input="dateA"
            >
            </v-date-picker>
          </v-menu>
        </v-col>
      </v-row>
      <v-card flat>
        <v-tabs
          background-color="primary"
          dark
          v-model="tabs"
          class="mb-4"
        >
          <v-tab>
            <v-icon class="mr-1">
            </v-icon>
            Geral
          </v-tab>
          <v-tab :disabled="!ordem.id">
            <v-icon class="mr-1">
            </v-icon>
            Anúncios da Ordem do dia
          </v-tab>
          <v-tab
            :disabled="!ordem.id"
            @click="loadVotacoes"
          >
            <v-icon class="mr-1">
            </v-icon>
            Votações
          </v-tab>
        </v-tabs>
        <v-tabs-items v-model="tabs">
          <v-tab-item>
            <v-card
              flat
              class="py-2"
            >
              <v-row>
                <v-col
                  colls="12"
                  lg="10"
                  md="12"
                  sm="12"
                >
                  <v-text-field
                    label="Título.:"
                    v-model="ordem.titulo"
                    required
                    :readonly="mode === 'delete'"
                    dense
                    outlined
                  >
                  </v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col
                  cols="12"
                  md="2"
                >
                  <v-text-field
                    v-model="codSes"
                    label="Sessão"
                    dense
                    outlined
                    @change="loadSessao()"
                  >
                    <v-btn
                      class="btn-outer-right pa-0"
                      slot="append"
                      color="success"
                      tile
                      @click.prevent="loadDialogSessao"
                    >
                      <v-icon
                        class="mx-0"
                        color="white"
                      >
                        mdi-magnify
                      </v-icon>
                    </v-btn>
                  </v-text-field>
                </v-col>
                <v-col
                  cols="12"
                  md="10"
                >
                  <v-card-text class="py-0 mt-0">Sessão plenária<h4>{{ sessaoPlenaria }}</h4>
                  </v-card-text>
                </v-col>
              </v-row>
              <v-row>
                <v-col colls="12">
                  <v-card class="pa-2">
                    <ckeditor
                      :editor="editor"
                      v-model="ordem.ds_ordem"
                      :config="editorConfig"
                      placeholder="Observação..."
                      :readonly="mode === 'delete'"
                    ></ckeditor>
                  </v-card>
                </v-col>
              </v-row>
            </v-card>
          </v-tab-item>
          <v-tab-item>
            <v-card flat>
              <v-row justify="space-around">
                <v-col
                  cols="12"
                  md="12"
                >
                  <v-card
                    flat
                    class="py-2"
                  >
                    <v-data-table
                      :headers="headerMovim"
                      :items="movimentos"
                      :search="search"
                    >
                      <template v-slot:[`item.actions`]="{ item }">
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon
                              large
                              v-bind="attrs"
                              v-on="on"
                              color="success"
                              class="mr-2"
                              @click="loadMVotacao(item, tpSessao = 'votacao')"
                            >
                              mdi-arrange-send-backward
                            </v-icon>
                          </template>
                          <span>Abrir sessão de emendas</span>
                        </v-tooltip>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon
                              large
                              v-bind="attrs"
                              v-on="on"
                              color="success"
                              class="mr-2"
                              @click="loadMOrdem(item, mode='updateM')"
                            >
                              mdi-square-edit-outline
                            </v-icon>
                          </template>
                          <span>Editar capa de votação</span>
                        </v-tooltip>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon
                              v-if="item.votacao === 0"
                              large
                              v-bind="attrs"
                              v-on="on"
                              color="success"
                              class="mr-2"
                              @click="loadCriaCapaVotacaoProjeto(item)"
                            >
                              mdi-vote-outline
                            </v-icon>
                          </template>
                          <span>Criar capa de votação</span>
                        </v-tooltip>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon
                              v-if="item.votado === 0"
                              v-bind="attrs"
                              v-on="on"
                              large
                              color="primary"
                              class="mr-2"
                              @click.prevent="loadAddVotos(item)"
                            >
                              mdi-ballot-outline
                            </v-icon>
                          </template>
                          <span>Abre tela para votação</span>
                        </v-tooltip>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon
                              v-if="item.votado === 1"
                              v-bind="attrs"
                              v-on="on"
                              large
                              color="success"
                              class="mr-2"
                              @click.prevent="loadAddVotos(item)"
                            >
                              mdi-ballot-outline
                            </v-icon>
                          </template>
                          <span>Abre tela de votação</span>
                        </v-tooltip>
                      </template>
                    </v-data-table>
                    <v-card-actions class="justify-end">
                      <v-btn
                        color="success"
                        class="ml-1 mb-3"
                        v-if="codigo"
                        @click="loadModalMovim"
                      >
                        <v-icon left>
                          mdi-archive-arrow-up-outline
                        </v-icon>
                        Adicionar
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-col>
              </v-row>
            </v-card>
          </v-tab-item>
          <v-tab-item>
            <v-card flat>
              <v-row justify="space-around">
                <v-col
                  cols="12"
                  md="12"
                >
                  <v-card
                    flat
                    class="py-2"
                  >
                    <v-data-table
                      :headers="headerVotacao"
                      :items="itemsVotacao"
                    >
                      <template v-slot:[`item.actions`]="{ item }">
                        <v-icon
                          large
                          color="success"
                          class="mr-2"
                          @click="loadMVotacao(item, tpSessao = 'votacao')"
                        >
                          mdi-arrange-send-backward
                        </v-icon>
                        <v-icon
                          large
                          color="success"
                          class="mr-2"
                          @click="loadMOrdem(item, mode='updateM')"
                        >
                          mdi-square-edit-outline
                        </v-icon>
                        <v-icon
                          v-if="item.votacao === 0"
                          large
                          color="success"
                          class="mr-2"
                          @click="loadCriaCapaVotacaoProjeto(item)"
                        >
                          mdi-vote-outline
                        </v-icon>
                      </template>
                    </v-data-table>
                    <v-card-actions class="justify-end">
                      <v-btn
                        color="success"
                        class="ml-1 mb-3"
                        v-if="codigo"
                        @click="loadModalMovim"
                      >
                        <v-icon left>
                          mdi-archive-arrow-up-outline
                        </v-icon>
                        Adicionar
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-col>
              </v-row>
            </v-card>
          </v-tab-item>
        </v-tabs-items>
        <v-card-actions>
          <v-row class="mt-1">
            <v-col
              cols="12"
              md="6"
            >
              <v-btn
                color="success"
                class="ml-1 mr-4"
                v-if="mode === 'save'"
                @click.prevent="save"
              >
                <v-icon left>
                  mdi-content-save-outline
                </v-icon>
                Salvar
              </v-btn>
              <v-btn
                color="success"
                class="ml-1 mr-4"
                v-if="mode === 'update'"
                @click.prevent="update"
              >
                <v-icon left>
                  mdi-content-save-edit-outline
                </v-icon>
                Atualizar
              </v-btn>
              <v-btn
                color="secondary"
                class="mr-4"
                @click="reset"
              >
                <v-icon left>
                  mdi-broom
                </v-icon>
                Limpar
              </v-btn>
              <v-btn
                v-if="ordem.id"
                color="error"
                class="mr-4"
                @click="remove"
              >
                <v-icon left>
                  mdi-trash-can-outline
                </v-icon>
                Deletar
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
      <v-container>
        <v-dialog
          v-model="dialogFilter"
          transition="dialog-bottom-transition"
          fullscreen
        >
          <template v-slot:default="dialogFilter">
            <v-card>
              <v-toolbar
                color="primary"
                dark
              >
                Pesquisar
              </v-toolbar>
              <v-card-title>
                <v-text-field
                  class="search"
                  v-model="search"
                  append-icon="mdi-magnify"
                  label="Pesquisar"
                  single-line
                  hide-details
                >
                </v-text-field>
              </v-card-title>
              <v-data-table
                :headers="headerOrdens"
                :items="ordens"
                :search="search"
              >
                <template v-slot:[`item.actions`]="{ item }">
                  <v-icon
                    large
                    color="success"
                    class="mr-2"
                    @click.prevent="loadOrdem(item, mode='update')"
                  >
                    mdi-arrow-down-bold-box
                  </v-icon>
                </template>
              </v-data-table>
              <v-card-actions class="justify-end">
                <v-btn
                  color="error"
                  @click="dialogFilter.value = false"
                >Fechar</v-btn>
              </v-card-actions>
            </v-card>
          </template>
        </v-dialog>
      </v-container>
      <!-- Dialog filtro de projetos -->
      <v-container>
        <v-dialog
          v-model="dialogFilterProjetos"
          transition="dialog-bottom-transition"
          fullscreen
        >
          <template v-slot:default="dialogFilterProjetos">
            <v-card>
              <v-toolbar
                color="primary"
                dark
              >
                Pesquisar
              </v-toolbar>
              <v-card-title>
                <v-text-field
                  class="search"
                  v-model="search"
                  append-icon="mdi-magnify"
                  label="Pesquisar"
                  single-line
                  hide-details
                >
                </v-text-field>
              </v-card-title>
              <v-data-table
                :headers="headerProjetos"
                :items="projetos"
                :search="search"
              >
                <template v-slot:[`item.actions`]="{ item }">
                  <v-icon
                    large
                    color="success"
                    class="mr-2"
                    @click.prevent="loadProjeto(item, mode='save')"
                  >
                    mdi-arrow-down-bold-box
                  </v-icon>
                </template>
              </v-data-table>
              <v-card-actions class="justify-end">
                <v-btn
                  color="error"
                  @click="dialogFilterProjetos.value = false"
                >Fechar</v-btn>
              </v-card-actions>
            </v-card>
          </template>
        </v-dialog>
      </v-container>
      <!-- Dialog filtro da sessao plenaria -->
      <v-container>
        <v-dialog
          v-model="dialogFilterSessao"
          transition="dialog-bottom-transition"
          fullscreen
        >
          <template v-slot:default="dialogFilterSessao">
            <v-card>
              <v-toolbar
                color="primary"
                dark
              >
                Pesquisar
              </v-toolbar>
              <v-card-title>
                <v-text-field
                  class="search"
                  v-model="search"
                  append-icon="mdi-magnify"
                  label="Pesquisar"
                  single-line
                  hide-details
                >
                </v-text-field>
              </v-card-title>
              <v-data-table
                :headers="headerSessoes"
                :items="sessoes"
                :search="search"
              >
                <template v-slot:[`item.actions`]="{ item }">
                  <v-icon
                    color="success"
                    large
                    class="mr-2"
                    @click.prevent="loadSessao(item, mode='update')"
                  >
                    mdi-arrow-down-bold-box
                  </v-icon>
                </template>
              </v-data-table>
              <v-card-actions class="justify-end">
                <v-btn
                  color="error"
                  @click="dialogFilterSessao.value = false"
                >Fechar</v-btn>
              </v-card-actions>
            </v-card>
          </template>
        </v-dialog>
      </v-container>
      <!-- Dialog de votaçao -->
      <v-container class="box-container">
        <v-dialog
          v-model="dialogFormCapaVotacao"
          transition="dialog-top-transition"
        >
          <v-card
            tile
            min-height="800"
          >
            <v-toolbar
              color="primary"
              dark
              class="mb-2"
              max-height="60"
            >
              Votação de projeto
            </v-toolbar>
            <div class="ml-4 mt-5">
              <v-form>
                <input
                  id="user-id"
                  type="hidden"
                  v-model="votacao.usuario"
                />
                <input
                  id="votacao-uid-ordem"
                  type="hidden"
                  v-model="votacao.uid_ordem"
                />
                <input
                  id="votacao-id"
                  type="hidden"
                  v-model="votacao.id"
                />
                <input
                  id="votacao-uid-sessao"
                  type="hidden"
                  v-model="votacao.uid_sessao"
                />
                <input
                  id="votacao-uid-projeto"
                  type="hidden"
                  v-model="votacao.uid_projeto"
                />
                <v-row>
                  <v-col
                    cols="12"
                    md="2"
                  >
                    <v-text-field
                      v-model="codVot"
                      label="Código"
                      dense
                      outlined
                    >
                    </v-text-field>
                  </v-col>
                  <v-col
                    colls="12"
                    lg="3"
                    md="4"
                    v-if="votacao.id"
                  >
                    <v-checkbox
                      v-model="votacao.inativar"
                      label="Inativar votação?"
                      color="success"
                      class="mt-4"
                    >
                    </v-checkbox>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                    cols="12"
                    md="10"
                  >
                    <v-text-field
                      v-model="votacao.titulo"
                      label="Título"
                      dense
                      outlined
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                    colls="12"
                    md="4"
                  >
                    <v-text-field
                      v-model="qtvotosSim.s"
                      label="Votos sim.:"
                      dense
                      outlined
                    ></v-text-field>
                  </v-col>
                  <v-col
                    colls="12"
                    md="4"
                  >
                    <v-text-field
                      v-model="qtvotosNao.n"
                      label="Votos não.:"
                      dense
                      outlined
                    ></v-text-field>
                  </v-col>
                  <v-col
                    colls="12"
                    md="4"
                  >
                    <v-text-field
                      v-model="qtvotosAbs.a"
                      label="Abstenção.:"
                      dense
                      outlined
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                    colls="12"
                    md="4"
                  >
                    <v-autocomplete
                      label="Situação:"
                      v-model="votacao.uid_resultado"
                      :items="situacoes"
                      dense
                      outlined
                    >
                    </v-autocomplete>
                  </v-col>
                  <v-col
                    cols="12"
                    md="3"
                    lg="2"
                  >
                    <v-menu
                      v-model="menu3"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-mask="datvot"
                          v-model="data_vot"
                          label="Data da votação.:"
                          dense
                          outlined
                          @blur="mudaDataD"
                        >
                          <v-icon
                            slot="append"
                            color="success"
                            large
                            v-bind="attrs"
                            v-on="on"
                          >
                            mdi-calendar
                          </v-icon>
                        </v-text-field>
                      </template>
                      <v-date-picker
                        locale="pt-br"
                        v-model="date3"
                        @input="dateD"
                      >
                      </v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col
                    cols="12"
                    md="3"
                    lg="2"
                  >
                    <v-text-field
                      v-model="votacao.hora_inicio"
                      type="text"
                      label="Hora início"
                      v-mask="horaini"
                      outlined
                      dense
                    >
                    </v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    md="3"
                    lg="2"
                  >
                    <v-text-field
                      v-model="votacao.hora_fim"
                      type="text"
                      label="Término do evento"
                      v-mask="horafim"
                      outlined
                      dense
                    >
                    </v-text-field>
                  </v-col>
                </v-row>
                <v-card flat>
                  <v-tabs
                    background-color="primary"
                    dark
                    v-model="tabsVotacao"
                    class="mb-4"
                  >
                    <v-tab>Votação</v-tab>
                    <v-tab>Observações</v-tab>
                  </v-tabs>
                  <v-tabs-items v-model="tabsVotacao">
                    <v-tab-item>
                      <v-card
                        flat
                        class="py-2"
                      >
                        <v-data-table
                          :headers="headerPresenca"
                          :items="presencas"
                          fixed-header
                          height="350px"
                          dense
                          hide-default-footer
                          class="elevation-1"
                        >
                          <template v-slot:[`item.sim`]="{ item }">
                            <v-checkbox
                              v-model="item.sim"
                              color="success"
                              dense
                              style="height: 30px;"
                            >
                            </v-checkbox>
                          </template>
                          <template v-slot:[`item.nao`]="{ item }">
                            <v-checkbox
                              v-model="item.nao"
                              color="success"
                              dense
                              style="height: 30px;"
                            >
                            </v-checkbox>
                          </template>
                          <template v-slot:[`item.abstencao`]="{ item }">
                            <v-checkbox
                              v-model="item.abstencao"
                              color="success"
                              dense
                              style="height: 30px;"
                            >
                            </v-checkbox>
                          </template>
                        </v-data-table>
                        <v-card-actions class="justify-end">
                          <v-btn
                            v-if="votacao.votado === 0"
                            color="success"
                            class="ml-1 mb-3"
                            @click="saveVotacao"
                          >
                            <v-icon left>
                              mdi-plus
                            </v-icon>
                            Salvar votação
                          </v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-tab-item>
                    <v-tab-item>
                      <v-card
                        flat
                        class="py-2"
                      >
                        <v-row>
                          <v-col colls="12">
                            <v-card class="pa-2">
                              <ckeditor
                                :editor="editor"
                                v-model="votacao.ds_votacao"
                                :config="editorConfig"
                                placeholder="Observação..."
                              ></ckeditor>
                            </v-card>
                          </v-col>
                        </v-row>
                      </v-card>
                    </v-tab-item>
                  </v-tabs-items>
                </v-card>
              </v-form>
            </div>
            <v-card-actions class="justify-end">
              <v-btn
                color="success"
                class="mr-4"
                type="submit"
                v-if="votacao.id"
                @click.prevent="atualizaVotos()"
              >
                <v-icon left>
                  mdi-reload
                </v-icon>
                Atualizar votos
              </v-btn>
              <v-btn
                color="success"
                class="mr-4"
                type="submit"
                v-if="votacao.id"
                @click.prevent="saveCapaVotacao()"
              >
                <v-icon left>
                  mdi-content-save
                </v-icon>
                Atualizar
              </v-btn>
              <v-btn
                color="success"
                class="mr-4"
                v-if="!votacao.id"
                type="submit"
                @click.prevent="saveCapaVotacao()"
              >
                <v-icon left>
                  mdi-content-save
                </v-icon>
                Salvar
              </v-btn>
              <v-btn
                color="danger"
                class="mr-4"
                @click="FecharDialogSessaoVotacao"
              >
                <v-icon left>
                  mdi-close-box-outline
                </v-icon>
                Sair
              </v-btn>
              <v-btn
                color="error"
                class="mr-4"
                @click="delVotacao"
              >
                <v-icon left>
                  mdi-broom
                </v-icon>
                deleter
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-container>
      <!-- Dialog de abertura de votaçao -->
      <v-container>
        <v-dialog
          v-model="dialogVotacao"
          transition="dialog-top-transition"
        >
          <v-card tile>
            <v-toolbar
              color="primary"
              dark
              class="mb-2"
            >
              Criar ou editar capa de votacao
            </v-toolbar>
            <div class="ml-4 mt-5">
              <v-form>
                <input
                  id="user-id"
                  type="hidden"
                  v-model="votacao.usuario"
                />
                <input
                  id="votacao-uid-ordem"
                  type="hidden"
                  v-model="votacao.uid_ordem"
                />
                <input
                  id="votacao-id"
                  type="hidden"
                  v-model="votacao.id"
                />
                <input
                  id="votacao-uid-sessao"
                  type="hidden"
                  v-model="votacao.uid_sessao"
                />
                <input
                  id="votacao-uid-projeto"
                  type="hidden"
                  v-model="votacao.uid_projeto"
                />
                <v-row>
                  <v-col
                    cols="12"
                    md="2"
                  >
                    <v-text-field
                      v-model="codVot"
                      label="Código"
                      dense
                      outlined
                    >
                    </v-text-field>
                  </v-col>
                  <v-col
                    colls="12"
                    lg="3"
                    md="4"
                    v-if="votacao.id"
                  >
                    <v-checkbox
                      v-model="votacao.inativar"
                      label="Inativar votação?"
                      color="success"
                      class="mt-4"
                    >
                    </v-checkbox>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                    colls="12"
                    md="4"
                  >
                    <v-autocomplete
                      label="Situação:"
                      v-model="votacao.uid_resultado"
                      :items="situacoes"
                      dense
                      outlined
                    >
                    </v-autocomplete>
                  </v-col>
                  <v-col
                    cols="12"
                    md="3"
                    lg="2"
                  >
                    <v-menu
                      v-model="menu3"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-mask="datvot"
                          v-model="data_vot"
                          label="Data da votação.:"
                          dense
                          outlined
                          @blur="mudaDataD"
                        >
                          <v-icon
                            slot="append"
                            color="success"
                            large
                            v-bind="attrs"
                            v-on="on"
                          >
                            mdi-calendar
                          </v-icon>
                        </v-text-field>
                      </template>
                      <v-date-picker
                        locale="pt-br"
                        v-model="date3"
                        @input="dateD"
                      >
                      </v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col
                    cols="12"
                    md="3"
                    lg="2"
                  >
                    <v-text-field
                      v-model="votacao.hora_inicio"
                      type="text"
                      label="Hora início"
                      v-mask="horaini"
                      outlined
                      dense
                    >
                    </v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    md="3"
                    lg="2"
                  >
                    <v-text-field
                      v-model="votacao.hora_fim"
                      type="text"
                      label="Término do evento"
                      v-mask="horafim"
                      outlined
                      dense
                    >
                    </v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                    cols="12"
                    md="10"
                  >
                    <v-text-field
                      v-model="votacao.titulo"
                      label="Título"
                      dense
                      outlined
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col colls="12">
                    <v-card class="pa-2">
                      <ckeditor
                        :editor="editor"
                        v-model="votacao.ds_votacao"
                        :config="editorConfig"
                        placeholder="Observação..."
                      ></ckeditor>
                    </v-card>
                  </v-col>
                </v-row>
              </v-form>
            </div>
            <v-card-actions class="justify-end">
              <v-btn
                color="success"
                class="mr-4"
                type="submit"
                v-if="votacao.id"
                @click.prevent="saveCapaVotacao()"
              >
                <v-icon left>
                  mdi-content-save
                </v-icon>
                Atualizar
              </v-btn>
              <v-btn
                color="success"
                class="mr-4"
                v-if="!votacao.id"
                type="submit"
                @click.prevent="saveCapaVotacao()"
              >
                <v-icon left>
                  mdi-content-save
                </v-icon>
                Salvar
              </v-btn>
              <v-btn
                color="danger"
                class="mr-4"
                @click="FecharDialogVotacao"
              >
                <v-icon left>
                  mdi-close-box-outline
                </v-icon>
                Sair
              </v-btn>
              <v-btn
                color="error"
                class="mr-4"
                @click="delVotacao"
              >
                <v-icon left>
                  mdi-broom
                </v-icon>
                deleter
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-container>
      <!-- Dialog de movimento -->
      <v-container>
        <v-dialog
          v-model="dialogAnuncios"
          transition="dialog-top-transition"
        >
          <v-card tile>
            <v-toolbar
              color="primary"
              dark
              class="mb-2"
            >
              Adicionar ou editar atos do dia
            </v-toolbar>
            <div class="ml-4 mt-5">
              <v-form>
                <input
                  id="user-id"
                  type="hidden"
                  v-model="movimento.usuario"
                />
                <input
                  id="uuid-id"
                  type="hidden"
                  v-model="movimento.uid_ordem"
                />
                <input
                  id="uid-sessao"
                  type="hidden"
                  v-model="movimento.uid_sessao"
                />
                <input
                  id="movimento-id"
                  type="hidden"
                  v-model="movimento.id"
                />
                <v-row>
                  <v-col
                    cols="12"
                    md="2"
                  >
                    <v-text-field
                      v-model="codMov"
                      label="Código"
                      dense
                      outlined
                    >
                    </v-text-field>
                  </v-col>
                  <v-col
                    colls="12"
                    lg="3"
                    md="4"
                    v-if="movimento.id"
                  >
                    <v-checkbox
                      v-model="movimento.inativar"
                      label="Inativar este ítem?"
                      color="success"
                      class="mt-4"
                    >
                    </v-checkbox>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                    cols="12"
                    md="2"
                    lg="2"
                  >
                    <v-text-field
                      v-model="movimento.ordem"
                      type="text"
                      label="Odrdenação"
                      outlined
                      dense
                    >
                    </v-text-field>
                  </v-col>
                  <v-col
                    colls="12"
                    lg="3"
                    md="4"
                  >
                    <v-autocomplete
                      label="Classificação:"
                      v-model="movimento.uid_tipo"
                      :items="tipo"
                      dense
                      outlined
                    >
                    </v-autocomplete>
                  </v-col>
                  <v-col
                    cols="12"
                    md="3"
                    lg="2"
                  >
                    <v-menu
                      v-model="menu2"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-mask="datmovin"
                          v-model="data_mov"
                          label="Data de publicacao.:"
                          dense
                          outlined
                          @blur="mudaDataC"
                        >
                          <v-icon
                            slot="append"
                            color="success"
                            large
                            v-bind="attrs"
                            v-on="on"
                          >
                            mdi-calendar
                          </v-icon>
                        </v-text-field>
                      </template>
                      <v-date-picker
                        locale="pt-br"
                        v-model="date2"
                        @input="dateC"
                      >
                      </v-date-picker>
                    </v-menu>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                    cols="12"
                    md="2"
                  >
                    <v-text-field
                      v-model="codProjeto"
                      label="Projeto"
                      dense
                      outlined
                      @change="loadOrdem()"
                    >
                      <v-btn
                        class="btn-outer-right pa-0"
                        slot="append"
                        color="success"
                        tile
                        @click.prevent="dialogProjetos"
                      >
                        <v-icon
                          class="mx-0"
                          color="white"
                        >
                          mdi-magnify
                        </v-icon>
                      </v-btn>
                    </v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    md="10"
                  >
                    <v-text-field
                      v-model="movimento.titulo"
                      label="Título"
                      dense
                      outlined
                    ></v-text-field>
                  </v-col>
                </v-row>
                <!-- Lista emendas apresentadas ao projeto -->
                <v-card v-if="tpSessao === 'votacao'">
                  <v-data-table
                    :headers="headerEmendas"
                    :items="emendas"
                  >
                    <template v-slot:[`item.actions`]="{ item }">
                      <v-icon
                        v-if="!item.votacao"
                        large
                        color="success"
                        class="mr-2"
                        @click.prevent="loadCriaCapaVotacaoEmendas(item)"
                      >
                        mdi-vote-outline
                      </v-icon>
                      <v-icon
                        v-if="item.votacao"
                        large
                        color="success"
                        class="mr-2"
                        @click.prevent="loadAddVotos(item)"
                      >
                        mdi-ballot-outline
                      </v-icon>
                    </template>
                  </v-data-table>
                </v-card>
                <v-row>
                  <v-col colls="12">
                    <v-card class="pa-2">
                      <ckeditor
                        :editor="editor"
                        v-model="movimento.ds_movim"
                        :config="editorConfig"
                        placeholder="Observação..."
                        :readonly="mode === 'deleteM'"
                      ></ckeditor>
                    </v-card>
                  </v-col>
                </v-row>
              </v-form>
            </div>
            <v-card-actions class="justify-end">
              <v-btn
                color="success"
                class="mr-4"
                type="submit"
                v-show="mode === 'updateM'"
                @click.prevent="saveMov()"
              >
                <v-icon left>
                  mdi-content-save
                </v-icon>
                Atualizar
              </v-btn>
              <v-btn
                color="success"
                class="mr-4"
                v-show="mode === 'save'"
                type="submit"
                @click.prevent="saveMov()"
              >
                <v-icon left>
                  mdi-content-save
                </v-icon>
                Salvar
              </v-btn>
              <v-btn
                color="danger"
                class="mr-4"
                @click="FecharDialog"
              >
                <v-icon left>
                  mdi-close-box-outline
                </v-icon>
                Sair
              </v-btn>
              <v-btn
                color="error"
                class="mr-4"
                @click="delMovimento"
              >
                <v-icon left>
                  mdi-broom
                </v-icon>
                deleter
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-container>
    </v-card>
  </v-container>
</template>

<script>
import { mapState } from 'vuex'
import { uuid } from 'vue-uuid'
import { baseApiUrl, showError } from '@/global'
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'
import axios from 'axios'
import moment from 'moment'
export default {
  name: 'ordemMovin',
  computed: mapState(['user']),

  data: function () {
    return {
      errors: {},
      editor: ClassicEditor,
      editorConfig: {
      },
      pagina: 'votacao',
      datacad: '##/##/####',
      datenc: '##/##/####',
      datmovin: '##/##/####',
      datvot: '##/##/####',
      horaini: '##:##',
      horafim: '##:##',
      mode: 'save',
      sessaoPlenaria: '[ Nenhuma sessão selecionada ]',
      codSes: '',
      codMov: '',
      codVot: '',
      tpSessao: '',
      tabs: null,
      tabsVotacao: null,
      codigo: '',
      codProjeto: '',
      dialogFilter: false,
      dialogFilterSessao: false,
      dialogFilterProjetos: false,
      dialogAnuncios: false,
      dialogVotacao: false,
      dialogFormCapaVotacao: false,
      date0: new Date().toISOString().substr(0, 10),
      date1: new Date().toISOString().substr(0, 10),
      date2: new Date().toISOString().substr(0, 10),
      date3: new Date().toISOString().substr(0, 10),
      data_cad: '',
      data_enc: '',
      data_mov: '',
      data_vot: '',
      menu: false,
      menu1: false,
      menu2: false,
      menu3: false,
      search: null,
      uuid: '',
      ordem: {},
      ordens: [],
      sessao: {},
      sessoes: [],
      situacoes: [],
      tipos: [],
      movimento: {},
      projeto: {},
      projetos: [],
      emenda: {},
      votacao: {},
      votacaoSinc: {},
      qtvotosSim: {},
      qtvotosNao: {},
      qtvotosAbs: {},
      emendas: [],
      movimentos: [],
      itemsVotacao: [],
      presencas: [],
      tipo: [],
      loading: false,
      filter: null,
      filterOn: [],
      headerOrdens: [
        {
          text: 'Cód',
          align: 'start',
          sortable: false,
          value: 'id'
        },
        { text: 'Título', value: 'titulo' },
        { text: 'Data', value: 'cadastro' },
        { text: 'Situação', value: 'situacao' },
        { text: 'Ações', value: 'actions', sortable: false }
      ],
      headerProjetos: [
        {
          text: 'Cód',
          align: 'start',
          sortable: false,
          value: 'id'
        },
        { text: 'Processo', value: 'processo' },
        { text: 'Ano', value: 'ano' },
        { text: 'Projeto', value: 'projeto' },
        { text: 'Título', value: 'titulo' },
        { text: 'Tipo', value: 'abv_tipo' },
        { text: 'Autor', value: 'tp_autor' },
        { text: 'Data', value: 'cadastro' },
        { text: 'Situação', value: 'situacao' },
        { text: 'Ações', value: 'actions', sortable: false }
      ],
      headerPresenca: [
        {
          text: 'Cód',
          align: 'start',
          sortable: false,
          value: 'uid_vereador'
        },
        { text: 'Nome', value: 'nome' },
        { text: 'Sim', value: 'sim' },
        { text: 'Não', value: 'nao' },
        { text: 'Abstenção', value: 'abstencao' },
        { text: 'Seguir', value: 'actions', sortable: false }
      ],
      headerEmendas: [
        {
          text: 'Cód',
          align: 'start',
          sortable: false,
          value: 'id'
        },
        { text: 'Nr. emenda', value: 'nr_emenda' },
        { text: 'Título', value: 'titulo' },
        { text: 'Data', value: 'cadastro' },
        { text: 'Autoria', value: 'autoria' },
        { text: 'P/ votação', value: 'votar' },
        { text: 'Votado', value: 'voto' },
        { text: 'Situação', value: 'situacao' },
        { text: 'Ações', value: 'actions', sortable: false }
      ],
      headerSessoes: [
        {
          text: 'Cód',
          align: 'start',
          sortable: false,
          value: 'id'
        },
        { text: 'Título', value: 'titulo' },
        { text: 'Data', value: 'cadastro' },
        { text: 'Situação', value: 'situacao' },
        { text: 'Ações', value: 'actions', sortable: false }
      ],
      headerMovim: [
        {
          text: 'Cód',
          align: 'start',
          sortable: false,
          value: 'id'
        },
        { text: 'Cod. proc.', value: 'uid_processo' },
        { text: 'Projeto', value: 'titulo' },
        { text: 'P/ votação', value: 'votac' },
        { text: 'Votado', value: 'votad' },
        { text: 'Situação', value: 'situacao' },
        { text: 'Ações', value: 'actions', sortable: false }
      ],
      headerVotacao: [
        {
          text: 'Cód',
          align: 'start',
          sortable: false,
          value: 'id'
        },
        { text: 'Ordem do dia.', value: 'ordem' },
        { text: 'Projeto', value: 'titulo' },
        { text: 'Situação', value: 'situacao' },
        { text: 'Ações', value: 'actions', sortable: false }
      ]
    }
  },
  methods: {
    mudaDataA () {
      const [dia, mes, ano] = this.data_cad.split('/')
      if (this.data_cad) {
        this.ordem.data_criacao = `${ano}-${mes.padStart(2, '0')}-${dia.padStart(2, '0')}`
      }
    },
    dateA () {
      this.data_cad = moment(this.date0).format('DD/MM/YYYY')
      this.menu = false
      const [dia, mes, ano] = this.data_cad.split('/')
      this.ordem.data_criacao = `${ano}-${mes.padStart(2, '0')}-${dia.padStart(2, '0')}`
    },
    mudaDataB () {
      const [dia, mes, ano] = this.data_enc.split('/')
      if (this.data_enc) {
        this.ordem.data_encerramento = `${ano}-${mes.padStart(2, '0')}-${dia.padStart(2, '0')}`
      }
    },
    dateB () {
      this.data_enc = moment(this.date1).format('DD/MM/YYYY')
      this.menu1 = false
      const [dia, mes, ano] = this.data_enc.split('/')
      this.ordem.data_encerramento = `${ano}-${mes.padStart(2, '0')}-${dia.padStart(2, '0')}`
    },
    mudaDataC () {
      const [dia, mes, ano] = this.data_mov.split('/')
      if (this.data_mov) {
        this.movimento.data_publicacao = `${ano}-${mes.padStart(2, '0')}-${dia.padStart(2, '0')}`
      }
    },
    dateC () {
      this.data_mov = moment(this.date2).format('DD/MM/YYYY')
      this.menu2 = false
      const [dia, mes, ano] = this.data_mov.split('/')
      this.movimento.data_publicacao = `${ano}-${mes.padStart(2, '0')}-${dia.padStart(2, '0')}`
    },
    mudaDataD () {
      const [dia, mes, ano] = this.data_vot.split('/')
      if (this.data_vot) {
        this.votacao.data_votacao = `${ano}-${mes.padStart(2, '0')}-${dia.padStart(2, '0')}`
      }
    },
    dateD () {
      this.data_vot = moment(this.date3).format('DD/MM/YYYY')
      this.menu3 = false
      const [dia, mes, ano] = this.data_vot.split('/')
      this.votacao.data_votacao = `${ano}-${mes.padStart(2, '0')}-${dia.padStart(2, '0')}`
    },
    save () {
      const mode = this.mode
      const method = this.ordem.id ? 'put' : 'post'
      const id = this.ordem.id ? `/${this.ordem.id}` : ''
      axios[method](`${baseApiUrl}/ordem-do-dia${id}`, this.ordem)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          if (mode === 'save') {
            this.reset()
          }
        })
        .catch(showError)
    },
    update () {
      const method = this.ordem.id ? 'put' : 'post'
      const id = this.ordem.id ? `/${this.ordem.id}` : ''
      axios[method](`${baseApiUrl}/ordem-do-dia${id}`, this.ordem)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          this.loadOrdem()
        })
        .catch(showError)
    },
    saveMov () {
      const method = this.movimento.id ? 'put' : 'post'
      const id = this.movimento.id ? `/${this.movimento.id}` : ''
      axios[method](`${baseApiUrl}/movimento-da-ordem-do-dia${id}`, this.movimento)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          this.clearMovimento()
          this.loadAnuncios()
          this.dialogAnuncios = false
        })
        .catch(showError)
    },
    saveCapaVotacao () {
      const method = this.votacao.id ? 'put' : 'post'
      const id = this.votacao.id ? `/${this.votacao.id}` : ''
      axios[method](`${baseApiUrl}/votacoes${id}`, this.votacao)
        .then(() => {
          this.$toasted.global.defaultSuccess()
        })
        .catch(showError)
    },
    delVotacao () {

    },
    saveVotacao () {
      const method = 'post'
      axios[method](`${baseApiUrl}/votacao-de-projetos`, this.presencas)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          this.sinc()
        })
        .catch(showError)
    },
    sinc () {
      const id = this.votacao.id
      const method = 'put'
      axios[method](`${baseApiUrl}/votacoes-sinc/${id}`, this.votacaoSinc)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          this.loadVotacao()
        })
        .catch(showError)
    },
    delMovimento () {
      const id = this.movimento.id
      if (confirm('Deseja realmente deletar este anúncio?')) {
        axios.delete(`${baseApiUrl}/movimento-da-ordem-do-dia/${id}`)
          .then(() => {
            this.$toasted.global.defaultSuccess()
            this.loadAnuncios()
            this.dialogAnuncios = false
          })
          .catch(showError)
      }
    },
    remove () {
      const id = this.ordem.id
      if (confirm('Deseja realmente deletar esta ordem do dia?')) {
        axios.delete(`${baseApiUrl}/ordem-do-dia/${id}`)
          .then(() => {
            this.$toasted.global.defaultSuccess()
            this.reset()
          })
          .catch(showError)
      }
    },
    FecharDialog () {
      this.dialogAnuncios = false
      this.tpSessao = ''
      this.mode = 'save'
      this.clearMovimento()
    },
    FecharDialogVotacao () {
      this.dialogVotacao = false
      this.votacao = {}
      this.codVot = ''
    },
    FecharDialogSessaoVotacao () {
      this.dialogFormCapaVotacao = false
      this.votacao = {}
      this.codVot = ''
    },
    clearMovimento () {
      this.movimento = {}
      this.movimento.usuario = this.user.id
    },
    reset () {
      this.mode = 'save'
      this.sessaoPlenaria = '[ Nenhuma sessão selecionada ]'
      this.codSes = ''
      this.codMov = ''
      this.codVot = ''
      this.codigo = ''
      this.tpSessao = ''
      this.ordem = {}
      this.data_cad = ''
      this.data_enc = ''
      this.votacaoSinc = {}
      this.ordens = []
      this.projetos = []
      this.movimentos = []
      this.sessoes = []
      this.ordem.usuario = this.user.id
      this.ordem.uuid = uuid.v1()
    },
    loadOrdem (item, mode) {
      const mod = mode || this.mode
      const id = this.codigo ? this.codigo : item.id
      const url = `${baseApiUrl}/ordem-do-dia-select-update/${id}`
      axios.get(url).then(res => {
        this.ordem = res.data
        this.codigo = this.ordem.id
        const idOrdem = this.ordem.id
        this.codSes = this.ordem.uid_sessao
        if (!this.ordem.data_criacao) {
          this.data_cad = ''
        } else {
          this.data_cad = moment(this.ordem.data_criacao).format('DD/MM/YYYY')
          this.ordem.data_criacao = moment(this.ordem.data_criacao).format('YYYY-MM-DD')
        }
        //        this.loadAnexos()
        this.loadSessao()
        this.loadAnuncios(idOrdem)
      })
      this.mode = mod
      this.dialogFilter = false
    },
    loadSessao (item, mode) {
      const mod = mode || this.mode
      const id = this.codSes ? this.codSes : item.id
      const url = `${baseApiUrl}/sessao-plenaria-up/${id}`
      axios.get(url).then(res => {
        this.sessao = res.data
        this.codSes = this.sessao.id
        this.ordem.uid_sessao = this.sessao.id
        this.sessaoPlenaria = this.sessao.titulo
      })
      this.mode = mod
      this.dialogFilterSessao = false
    },
    loadProjeto (item, mode) {
      this.mode = mode
      this.codProjeto = item.id
      this.movimento.uid_processo = item.id
      this.movimento.titulo = 'Proc. ' + item.processo + '/' + String(item.ano).substr(-2, 2) + '-' + item.abv_tipo + '.' + item.projeto + '/' + String(item.ano_projeto).substr(-2, 2) + '--' + item.titulo
      this.dialogFilterProjetos = false
    },
    loadCriaCapaVotacaoProjeto (item) {
      console.log(item)
      this.votacao.uid_sessao = this.sessao.id
      this.votacao.uid_projeto = item.id
      this.votacao.uid_processo = item.uid_processo
      this.votacao.uid_ordem = item.ordem
      this.votacao.titulo = item.titulo
      this.votacao.tipo = 'projeto'
      this.votacao.projeto = true
      this.dialogVotacao = true
    },
    loadCriaCapaVotacaoEmendas (item) {
      const id = item.id
      const url = `${baseApiUrl}/emendas-para-votacao/${id}`
      axios.get(url).then(res => {
        this.emenda = res.data
        this.votacao.uid_sessao = this.sessao.id
        this.votacao.uid_projeto = this.emenda.id
        this.votacao.uid_ordem = this.ordem.id
        this.votacao.tipo = 'emenda'
        this.votacao.titulo = 'Proc' + this.emenda.processo + '/' + String(this.emenda.ano).substr(-2, 2) + '-' + this.emenda.abv_tipo + '.' + this.emenda.projeto + '/' + String(this.emenda.ano_projeto).substr(-2, 2) + '--Emenda-' + this.emenda.nr_emenda
      })
      this.dialogVotacao = true
    },
    // loadAddVotos (item) {
    //   const id = item.id
    //   const idSes = item.uid_sessao
    //   const url = `${baseApiUrl}/votacao-select-update/${id}/sessao?uid=${idSes}`
    //   axios.get(url).then(res => {
    //     this.votacao = res.data
    //     this.codVot = this.votacao.id
    //     const idSes = this.votacao.uid_sessao
    //     const idVot = this.votacao.id
    //     const vot = this.votacao.votado
    //     if (!this.votacao.data_votacao) {
    //       this.data_vot = ''
    //     } else {
    //       this.data_vot = moment(this.votacao.data_votacao).format('DD/MM/YYYY')
    //       this.votacao.data_votacao = moment(this.votacao.data_votacao).format('YYYY-MM-DD')
    //     }
    //     if (vot === 0) {
    //       this.loadQuorum(idSes)
    //     } if (vot === 1) {
    //       this.loadVotos(idVot)
    //     }
    //   })
    //   this.dialogFormCapaVotacao = true
    // },
    loadAddVotos (item) {
      const id = item.id
      const idSes = item.uid_sessao || this.movimento.uid_sessao
      const url = `${baseApiUrl}/votacao-select-update/${id}/sessao?uid=${idSes}`
      axios.get(url).then(res => {
        this.votacao = res.data
        this.codVot = this.votacao.id
        const idSes = this.votacao.uid_sessao
        const idVot = this.votacao.id
        const vot = this.votacao.votado
        if (!this.votacao.data_votacao) {
          this.data_vot = ''
        } else {
          this.data_vot = moment(this.votacao.data_votacao).format('DD/MM/YYYY')
          this.votacao.data_votacao = moment(this.votacao.data_votacao).format('YYYY-MM-DD')
        }
        if (vot === 0) {
          this.loadQuorum(idSes)
        } if (vot === 1) {
          this.loadVotos(idVot)
        }
      })
      this.dialogFormCapaVotacao = true
    },
    loadVotacao () {
      const id = this.votacao.id
      const url = `${baseApiUrl}/votacoese/${id}`
      axios.get(url).then(res => {
        this.votacao = res.data
        const idVot = this.votacao.id
        this.loadVotos(idVot)
      })
    },
    atualizaVotos () {
      const id = this.votacao.id
      const url = `${baseApiUrl}/votacao-count/${id}`
      axios.get(url).then(res => {
        this.qtvotosSim = res.data._vot
        this.votacao.sim = this.qtvotosSim.s
        this.qtvotosNao = res.data.nao
        this.votacao.nao = this.qtvotosNao.n
        this.qtvotosAbs = res.data.abs
        this.votacao.abstencoes = this.qtvotosAbs.a
      })
    },
    loadVotos (idVot) {
      const url = `${baseApiUrl}/votos-da-votacao/${idVot}`
      axios.get(url).then(res => {
        this.presencas = res.data.map(item => {
          return {
            ...item,
            uid_votacao: this.votacao.id,
            sim: item.sim,
            nao: item.nao,
            abstencao: item.abstencao,
            usuario: this.user.id
          }
        })
      })
    },
    loadVotacoes () {
      const id = this.ordem.id
      const url = `${baseApiUrl}/votacao-por-ordem-do-dia/${id}`
      axios.get(url).then(res => {
        this.itemsVotacao = res.data
      })
    },
    loadModalMovim () {
      this.movimento.usuario = this.user.id
      this.movimento.uid_ordem = this.ordem.id
      this.movimento.uid_sessao = this.ordem.uid_sessao
      this.dialogAnuncios = true
      this.loadClassificacao()
    },
    loadMOrdem (items, mode) {
      const mod = mode || this.mode
      const id = items.id
      const url = `${baseApiUrl}/movimento-da-ordem-do-dia-select-update/${id}`
      axios.get(url).then(res => {
        this.movimento = res.data
        this.codMov = this.movimento.id
        this.codProjeto = this.movimento.uid_processo
        if (!this.movimento.data_publicacao) {
          this.data_mov = ''
        } else {
          this.data_mov = moment(this.movimento.data_publicacao).format('DD/MM/YYYY')
          this.movimento.data_publicacao = moment(this.movimento.data_publicacao).format('YYYY-MM-DD')
        }
      })
      this.mode = mod
      this.dialogAnuncios = true
      this.loadClassificacao()
    },
    loadQuorum (idSes) {
      const url = `${baseApiUrl}/registro-de-presensa-para-votacao/${idSes}`
      axios.get(url).then(res => {
        this.presencas = res.data.map(item => {
          return {
            ...item,
            uid_votacao: this.votacao.id,
            sim: item.sim !== null,
            nao: item.nao === false,
            abstencao: item.abstencao === false,
            usuario: this.user.id
          }
        })
      })
      this.votacaoSinc.votado = true
      this.votacaoSinc.projeto = this.votacao.projeto
    },
    loadMVotacao (items, tpSessao) {
      this.tpSessao = tpSessao
      const id = items.id
      const url = `${baseApiUrl}/movimento-da-ordem-do-dia-select-update-para-votacao/${id}`
      axios.get(url).then(res => {
        this.movimento = res.data
        this.codMov = this.movimento.id
        this.codProjeto = this.movimento.uid_processo
        const idProjeto = this.movimento.uid_projeto
        if (!this.movimento.data_publicacao) {
          this.data_mov = ''
        } else {
          this.data_mov = moment(this.movimento.data_publicacao).format('DD/MM/YYYY')
          this.movimento.data_publicacao = moment(this.movimento.data_publicacao).format('YYYY-MM-DD')
        }
        this.loadEmendas(idProjeto)
      })
      this.dialogAnuncios = true
      this.loadClassificacao()
    },
    loadDialog () {
      this.dialogFilter = true
      this.loadFilter()
      this.codigo = ''
    },
    dialogProjetos () {
      this.dialogFilterProjetos = true
      this.loadFiltroProjetos()
    },
    loadDialogSessao () {
      this.dialogFilterSessao = true
      this.loadFilterSessao()
    },
    loadFilter () {
      const url = `${baseApiUrl}/ordem-do-dia-filtro`
      axios.get(url).then(res => {
        this.ordens = res.data.map(item => {
          return {
            ...item,
            cadastro: moment(item.data_criacao).format('DD/MM/YYYY'),
            situacao: item.inativar === 0 ? 'Ativo' : 'Inativo'
          }
        })
      })
    },
    loadFilterSessao () {
      const url = `${baseApiUrl}/filtro-de-sessao-por-ordem-do-dia`
      axios.get(url).then(res => {
        this.sessoes = res.data.map(item => {
          return {
            ...item,
            cadastro: moment(item.data_criacao).format('DD/MM/YYYY'),
            situacao: item.inativar === 0 ? 'Ativo' : 'Inativo'
          }
        })
      })
    },
    loadFiltroProjetos () {
      const url = `${baseApiUrl}/projetos-filtro-ordem`
      axios.get(url).then(res => {
        this.projetos = res.data.map(item => {
          return {
            ...item,
            cadastro: moment(item.data_criacao).format('DD/MM/YYYY'),
            situacao: item.inativar === 0 ? 'Ativo' : 'Inativo'
          }
        })
      })
    },
    loadEmendas (idProjeto) {
      const url = `${baseApiUrl}/emendas-por-projeto/${idProjeto}`
      axios.get(url).then(res => {
        this.emendas = res.data.map(item => {
          return {
            ...item,
            cadastro: moment(item.data_publicacao).format('DD/MM/YYYY'),
            situacao: item.inativar === 0 ? 'Ativo' : 'Inativo',
            votar: item.votacao === 0 ? 'Não' : 'Sim',
            voto: item.votado === 0 ? 'Não' : 'Sim'
          }
        })
      })
    },
    loadAnuncios (idOrdem) {
      const id = idOrdem
      const url = `${baseApiUrl}/movimento-da-ordem-do-dia-filtro/${id}`
      axios.get(url).then(res => {
        this.movimentos = res.data.map(item => {
          return {
            ...item,
            votac: item.votacao === 0 ? 'Não' : 'Sim',
            votad: item.votado === 0 ? 'Não' : 'Sim',
            situacao: item.inativar === 0 ? 'Ativo' : 'Inativo'
          }
        })
      })
    },
    loadClassificacao () {
      const url = `${baseApiUrl}/tipo-de-ordem`
      axios.get(url).then(res => {
        this.tipo = res.data.map(item => {
          return {
            value: item.id,
            text: `${item.tipo}`
          }
        })
      })
    },
    loadTipo () {
      const url = `${baseApiUrl}/tipo-de-ordem`
      axios.get(url).then(res => {
        this.tipos = res.data.map(item => {
          return {
            value: item.id,
            text: item.tipo
          }
        })
      })
    },
    loadSituacoes () {
      const id = this.pagina
      const url = `${baseApiUrl}/situacoes-por-processo/${id}`
      axios.get(url).then(res => {
        this.situacoes = res.data.map(item => {
          return {
            value: item.id,
            text: `${item.situacao}`
          }
        })
      })
    },
    loadUsers () {
      this.ordem.usuario = this.user.id
    }
  },
  watch: {
    Filter () {
      // this.loadFilter()
    }
  },
  created () {
    this.loadUsers()
    this.loadSituacoes()
  },
  mounted () {
    this.loadTipo()
    this.ordem.uuid = uuid.v1()
  }
}
</script>
<style scoped>
.btn-outer {
  margin-top: -7px !important;
  margin-left: -9px !important;
}
.btn-outer-right {
  margin-top: -7px !important;
  margin-right: -11px !important;
}
.v-size--default {
  height: 37px !important;
  min-width: 38px !important;
}
</style>
